import * as React from 'react';
import {
  Box,
  Button,
  Modal,
  Typography,
} from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

export function InstrumentRefreshPopup({ open, onClose, onConfirm }) {
  const severity = 'warning';
  const title = 'Confirm Refresh?';

  const severityConfig = {
    warning: {
      icon: <WarningAmberRoundedIcon sx={{ color: '#f9a825' }} />,
      color: '#f9a825',
    }
  };

  const cfg = severityConfig[severity] || severityConfig.warning;
  const headline = title;
  const primaryAction = {
    label: 'Okay',
    onClick: onConfirm
  };
  const secondaryAction = {
    label: 'Cancel',
    onClick: onClose
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="instrument-refresh-modal-title"
      aria-describedby="instrument-refresh-modal-description"
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(30, 60, 114, 0.6)',
          backdropFilter: 'blur(8px)'
        }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '480px' },
          maxWidth: '520px',
          bgcolor: '#ffffff',
          borderRadius: '20px',
          boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)',
          p: 3,
          outline: 'none'
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            mb: 1
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {cfg.icon}
            <Typography
              id="instrument-refresh-modal-title"
              variant="h6"
              sx={{ fontWeight: 700, color: '#2b2c40' }}
            >
              {headline}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            background: 'linear-gradient(135deg, #f7f9ff, #ecf1ff)',
            borderLeft: `4px solid ${cfg.color}`,
            borderRadius: '10px',
            p: 2,
            mb: 3
          }}
        >
          <Typography id="instrument-refresh-modal-description" sx={{ color: '#555', lineHeight: 1.6, fontSize: '14px' }}>
            Refreshing the instrument list might reset the chart state and if there are any unsaved changes on this chart, they will be lost. Do you want to continue?
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 1.5,
            justifyContent: 'center'
          }}
        >
          {primaryAction && (
            <Button
              variant="contained"
              onClick={primaryAction.onClick}
              fullWidth
              sx={{
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                color: '#fff',
                border: 'none',
                borderRadius: '25px',
                textTransform: 'none',
                fontWeight: 700,
                letterSpacing: 0.2,
                '&:hover': {
                  background: 'linear-gradient(135deg, #5a6fd8, #6a4190)',
                  boxShadow: '0 8px 20px rgba(102, 126, 234, 0.3)'
                }
              }}
            >
              {primaryAction.label}
            </Button>
          )}
          {secondaryAction && (
            <Button
              variant="outlined"
              onClick={secondaryAction.onClick}
              fullWidth
              sx={{
                borderRadius: '25px',
                textTransform: 'none',
                fontWeight: 700,
                letterSpacing: 0.2,
                borderColor: '#667eea',
                color: '#667eea',
                '&:hover': {
                  borderColor: '#667eea',
                  backgroundColor: 'rgba(102, 126, 234, 0.08)'
                }
              }}
            >
              {secondaryAction.label}
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
}